import { SelectOption } from "../../../packages/ui/form/select/SelectOption.js";
import { MONTH_OPTIONS } from "./MonthSelectorOptions.js";

export const MONTH_STAR_OPTIONS: SelectOption[] = [{ label: "*", value: "*" }, ...MONTH_OPTIONS];
